// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3jNyt","signatureBlock":"Footer_signatureBlock__24sGV","signature":"Footer_signature__3xT00"};